import MaintenancePage from './pages/MaintenancePage/MaintenancePage';
import './App.css';

function App() {
  return (
    <div className="App">
      <MaintenancePage />
    </div>
  );
}

export default App;
